<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Top Bar-->
				<div class="TopBar">
					<!--Date Range-->
					<div class="SearchOptions">
						<label>Start Date:</label>
						<p-calendar
							[disabled]="IsLoading() == true"
							showIcon="true"
							showButtonBar="true"
							showTime="true"
							[hourFormat]="12"
							[(ngModel)]="StartDT"
							name="StartDT"
							(ngModelChange)="onStartDTChange($event)"
						></p-calendar>

						<label style="margin-left: 10px">End Date:</label>
						<p-calendar
							[disabled]="IsLoading() == true"
							showIcon="true"
							showButtonBar="true"
							showTime="true"
							[hourFormat]="12"
							[(ngModel)]="EndDT"
							name="EndDT"
							(ngModelChange)="onEndDTChange($event)"
						></p-calendar>

						<label style="margin-left: 10px">Search Inside:</label>
						<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="SearchInside" />
					</div>

					<!--Buttons-->
					<div>
						<button [disabled]="IsLoading() == true" style="margin-left: 0px" class="btn btn-danger" (click)="onClearAll()">Clear All</button>
						<button [disabled]="IsLoading() == true" style="margin-left: 5px" class="btn btn-danger" (click)="onClearPoints()">Clear Points</button>
						<button [disabled]="IsLoading() == true" style="margin-left: 5px" class="btn btn-danger" (click)="onClearData()">Clear Data</button>
						<button [disabled]="IsLoading() == true" style="margin-left: 5px" class="btn btn-success" (click)="onLoad()">Load Data</button>
						<button [disabled]="IsLoading() == true" style="margin-left: 5px" class="btn btn-primary" (click)="onSearch()">Search</button>
						<button [disabled]="IsLoading() == true" style="margin-left: 5px" class="btn btn-primary" (click)="onDeselectAll()">
							Deselect All
						</button>

						<img (click)="onToggleInfo()" class="info-img" src="assets/images/info-24.png" />
					</div>

					<!--Info-->
					<div *ngIf="ShowInfo == true" style="margin-top: 10px">
						<h4>Instructions:</h4>
						<div class="InfoBorder">
							<label
								>&#9900; Click on the map to select where you want to search for bus and student data (You must have at least 3 points/a
								triangle)</label
							><br />
							<label>&#9900; Select date range using start and end date options in the top left</label><br />
							<label
								>&#9900; Pick if you want to search inside or outside a boundary. Outside/unchecked means everywhere except for inside the
								boundary.</label
							><br />
							<label>&#9900; Press the Load Data button to load all of the data in that boundary for the selected date range</label><br />
							<br />
						</div>

						<h4>Top Bar:</h4>
						<div class="InfoBorder">
							<label>Top Options (Date, etc.)</label><br />
							<label>&#9900; Start Date, End Date: Select date range to search for bus/student positions</label><br />
							<label
								>&#9900; Search Inside: When checked searches inside the shape that is drawn on the map. When it is unchecked it searchs for
								points that are outside the shape.</label
							><br />
							<br />
							<br />
							<label>Buttons:</label><br />
							<label>&#9900; Clear All: Deletes all the loaded data and points on the map</label><br />
							<label>&#9900; Clear Points: Deletes all the points that are being used to define a new boundary</label><br />
							<label>&#9900; Clear Data: Deletes data that was loaded.</label><br />
							<label>&#9900; Load Data: Loads Bus position and Student data based on the boundary, date range, and inside/outside checkbox.</label
							><br />
							<label>&#9900; Deselect All: Deselects all the selected items.</label><br />
							<br />
							<br />
							<label>Overlays (which items/markes to put on the map):</label><br />
							<label>&#9900; Show Bus Positions: Draws points on the map based on a bus's GPS Locations</label><br />
							<label>&#9900; Student Gets On Bus: Draws points on the map where a student swiped on the bus</label><br />
							<label>&#9900; Student Gets Off Bus: Draws points on the map where a student swiped off the bus</label><br />
							<label>&#9900; Show Geo Fences: Draws Geo Fences on the map (defined by Geo Fence Maintenance Page)</label><br />
							<label
								>&#9900; Hide Inactive Geo Fences: If Geo Fences are being displayed, it will hide the geofences that are sent to be
								inactive</label
							><br />
							<label
								>&#9900; <span style="color: Red">Hide Unselected</span>: Hides buses, points, paths, and students that aren't selected (items
								are selected by clicking on them or searching for them in the selector). <span style="color: Red">NOTE:</span> Nothing will show
								up if you haven't selected any items in the selector</label
							><br />
							<label>&#9900; Show Points: Show or hide points that are being used to define a new search boundary</label><br />
							<label>&#9900; Show Preview: Show or hide preview of the new search boundary</label><br />
							<label
								>&#9900; Show Heat Map: Shows a heat map of bus or student points to let the user know the general areas that buses and students
								have travelled. NOTE: this is for all date/time ranges</label
							><br />
							<label
								>&#9900; Show on Heatmap: Pick an option that sets the heat map's data. Ex. Can pick all, only student points, only bus
								positions, etc.</label
							><br />
							<br />
							<br />
							<label>Labels (what text displays next to a bus or student):</label><br />
							<br />
							<label>Bus Labels:</label><br />
							<label>&#9900; Bus Number: Displays which bus was at that location</label><br />
							<label>&#9900; Bus Route: Displays the route the bus was using (set in the driver's app)</label><br />
							<label>&#9900; Route Type: Displays the type of route, ex. Morning or Afternoon.</label><br />
							<label>&#9900; Date/Time: Displays when that point was recorded</label><br />
							<label>&#9900; Speed: Displays how fast the bus was going when it was at that location</label><br />
							<label>&#9900; Lat/Long: Displays latitude and longitude coordinates for that location</label><br />
							<label>&#9900; Driver: Displays who was driving the bus at that location</label><br />
							<label
								>&#9900; Bus Label Color: Select what color to use for bus labels. The Reset button sets the color to the default value.</label
							><br />
							<br />
							<label>Students:</label><br />
							<label>&#9900; Student Name: Displays Student's First and Last Name</label><br />
							<label>&#9900; Student ID: Displays Student's ID</label><br />
							<label
								>&#9900; Bus Entered or Exited: Displays the bus that recorded the transaction (which bus the student swiped on or off
								of)</label
							><br />
							<label>&#9900; Date/Time: Displays the time the student swiped on or off the bus at the marker's location</label><br />
							<label>&#9900; Scheduled Rider: Does the student belong on the bus they go on, or were they added manually?</label><br />
							<label
								>&#9900; Student Label Color: Select what color to use for student labels. Reset button sets the color to the default
								value.</label
							><br />
							<br />
						</div>

						<h4>Selector:</h4>
						<div class="InfoBorder">
							<label>&#9900; Selecting a bus will highlight the bus and show the stops it made.</label><br />
							<label>&#9900; Selecting a student will show their transactions and highlight the bus(es) they were on.</label><br />
							<br />
						</div>

						<h4>Map:</h4>
						<div class="InfoBorder">
							<label>Buses:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info about the bus at that point</label><br />
							<label>&#9900; Left Click: Selects the bus. </label><br />
							<br />
							<label>Students:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info</label><br />
							<label
								>&#9900; Left Click: Selects and highlights the student. If there are multiple student entries on the same spot, clicking on
								them will expand them in a spiral so you can see each entry. Pressing ESC or Delete will collapse the spiral</label
							><br />
							<label>&#9900; Students have an ON or OFF label underneath the icon which shows if they got on or off a bus at that stop</label
							><br />
							<br />
						</div>
					</div>

					<!--Display Options-->
					<div class="OptionsFlex">
						<!--Overlays-->
						<div class="OptionsBorder">
							<h5>Overlays</h5>

							<div class="OverlayGrid">
								<div>
									<label>Bus Positions</label>

									<div class="RadioGrid2Col">
										<label for="ShowBusLocation">Show Bus Positions:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusLocation"
											type="checkbox"
											[(ngModel)]="ShowBusLocation"
											(ngModelChange)="onShowBusLocationChange($event)"
										/>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Positions</label>

									<div class="RadioGrid2Col">
										<label for="ShowStudentsSwipeOn">Student Gets On Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentsSwipeOn"
											type="checkbox"
											[(ngModel)]="ShowStudentsSwipeOn"
											(ngModelChange)="onShowStudentsSwipeOnChange($event)"
										/>

										<label for="ShowStudentsSwipeOff">Student Gets Off Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentsSwipeOff"
											type="checkbox"
											[(ngModel)]="ShowStudentsSwipeOff"
											(ngModelChange)="onShowStudentsSwipeOffChange($event)"
										/>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Geo Fences</label>

									<div class="RadioGrid2Col">
										<label for="ShowGeoFences">Show Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowGeoFences"
											type="checkbox"
											[(ngModel)]="ShowGeoFences"
											(ngModelChange)="onShowGeoFencesChange($event)"
										/>

										<label for="HideInactiveGeoFences">Hide Inactive Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideInactiveGeoFences"
											type="checkbox"
											[(ngModel)]="HideInactiveGeoFences"
											(ngModelChange)="onHideInactiveGeoFencesChange($event)"
										/>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Misc.</label>

									<div class="RadioGrid2Col">
										<label style="color: Red" for="HideUnselected">Hide Unselected:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideUnselected"
											type="checkbox"
											[(ngModel)]="HideUnselected"
											(ngModelChange)="onHideUnselectedChange($event)"
										/>

										<label for="ShowNewPoints">Show Points:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowNewPoints"
											type="checkbox"
											[(ngModel)]="ShowNewPoints"
											(ngModelChange)="onShowNewPointsChange($event)"
										/>

										<label for="ShowPreview">Show Preview Shape:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowPreview"
											type="checkbox"
											[(ngModel)]="ShowPreview"
											(ngModelChange)="onShowPreviewChange($event)"
										/>

										<label for="ShowHeatMap">Show Heat Map:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowHeatMap"
											type="checkbox"
											[(ngModel)]="ShowHeatMap"
											(ngModelChange)="onShowHeatMapChange($event)"
										/>

										<label>Show on Heatmap:</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="HeatMapOptionID"
											[(ngModel)]="HeatMapOptionID"
											(ngModelChange)="onHeatMapOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstHeatMapOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>
									</div>
								</div>
							</div>
						</div>

						<!--Labels-->
						<div class="OptionsFlexItem OptionsBorder">
							<h5>Labels</h5>

							<div class="LabelGrid">
								<div>
									<label>Bus Labels</label>

									<div class="RadioGrid4Col">
										<label for="BusShowBusNbr">Bus Number:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowBusNbr"
											type="checkbox"
											[(ngModel)]="BusShowBusNbr"
											(ngModelChange)="onBusShowBusNbrChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="BusShowBusRouteDesc">Bus Route:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowBusRouteDesc"
											type="checkbox"
											[(ngModel)]="BusShowBusRouteDesc"
											(ngModelChange)="onBusShowBusRouteDescChange($event)"
										/>

										<label for="BusShowBusRouteTypeDesc">Route Type:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowBusRouteTypeDesc"
											type="checkbox"
											[(ngModel)]="BusShowBusRouteTypeDesc"
											(ngModelChange)="onBusShowBusRouteTypeDescChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="BusShowCDate">Date/Time:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowCDate"
											type="checkbox"
											[(ngModel)]="BusShowCDate"
											(ngModelChange)="onBusShowCDateChange($event)"
										/>

										<label for="BusShowSpeed">Speed:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowSpeed"
											type="checkbox"
											[(ngModel)]="BusShowSpeed"
											(ngModelChange)="onBusShowSpeedChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="BusShowLatLong">Lat/Long:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowLatLong"
											type="checkbox"
											[(ngModel)]="BusShowLatLong"
											(ngModelChange)="onBusShowLatLongChange($event)"
										/>

										<label for="BusShowDriver">Driver:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="BusShowDriver"
											type="checkbox"
											[(ngModel)]="BusShowDriver"
											(ngModelChange)="onBusShowDriverChange($event)"
										/>

										<label class="BusLabelMiddelColumn" [style.color]="BusTextColor">Bus Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="BusTextColor"
												(ngModelChange)="onBusTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetBusLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Labels</label>

									<div class="RadioGrid4Col">
										<label for="ShowStudentName">Student Name:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentName"
											type="checkbox"
											[(ngModel)]="ShowStudentName"
											(ngModelChange)="onShowStudentNameChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowStudentID">Student ID:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentID"
											type="checkbox"
											[(ngModel)]="ShowStudentID"
											(ngModelChange)="onShowStudentIDChange($event)"
										/>

										<label for="ShowStudentBus">Bus Entered/Exited:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentBus"
											type="checkbox"
											[(ngModel)]="ShowStudentBus"
											(ngModelChange)="onShowStudentBusChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowStudentScanTime">Date/Time:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentScanTime"
											type="checkbox"
											[(ngModel)]="ShowStudentScanTime"
											(ngModelChange)="onShowStudentScanTimeChange($event)"
										/>

										<label for="ShowScheduledRider">Scheduled Rider:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowScheduledRider"
											type="checkbox"
											[(ngModel)]="ShowScheduledRider"
											(ngModelChange)="onShowScheduledRiderChange($event)"
										/>

										<label class="BusLabelMiddelColumn" [style.color]="StudentTextColor">Student Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="StudentTextColor"
												(ngModelChange)="onStudentTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetStudentLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>

								<!-- <div class="VerticalBorder"></div> -->
							</div>
						</div>
					</div>
				</div>

				<!--Map-->
				<div
					[ngClass]="{
						MapGridOneCol: ShowSideBar == false,
						MapGridTwoCol: ShowSideBar == true
					}"
				>
					<p-gmap
						*ngIf="ShowMap == true"
						[overlays]="overlays"
						[options]="options"
						[style]="{ width: '100%', height: '625px' }"
						(onMapClick)="handleMapClick($event)"
						(onOverlayClick)="handleOverlayClick($event)"
						(onOverlayDragEnd)="onOverlayDragEnd($event)"
					></p-gmap>

					<!--Side Bar for searching for buses or students-->
					<div *ngIf="ShowSideBar == true">
						<!-- <caass-geo-fence-history-selector>
                        </caass-geo-fence-history-selector> -->

						<caass-bus-history-selector [StartDate]="StartDT" [EndDate]="EndDT" (SelectedChanged)="onSelectBusesOnMap($event)">
						</caass-bus-history-selector>
					</div>
				</div>

				<!--Table?-->

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
